import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const BotIcon60 = (props: SvgProps) => (
  <Svg
    width={62}
    height={62}
    fill="none"
    {...props}
  >
    <Path
      fill="#fff"
      stroke="#fff"
      d="M30.81 34.087c11.102.178 22.063 5.488 24.843 15.19.34 1.187-.003 2.288-.756 3.108-.76.828-1.939 1.364-3.23 1.364H10.333c-2.625 0-4.665-2.136-4.073-4.5 2.603-10.387 13.453-15.34 24.55-15.162Zm-.047 2.875c-10.495-.168-19.578 4.491-21.711 12.974l-.06.235.149.192c.016.02.034.042.054.064.213.229.621.447 1.138.447h41.334c.247 0 .478-.051.676-.136.167-.072.294-.162.384-.245l.226-.21-.087-.296C50.554 42.11 41.264 37.13 30.763 36.962ZM18.083 8.25h10.48v2.584h4.875V8.25h10.48a4.667 4.667 0 0 1 4.665 4.666v12.918a4.666 4.666 0 0 1-4.666 4.666H18.083a4.666 4.666 0 0 1-4.666-4.666V12.916a4.667 4.667 0 0 1 4.666-4.666Zm0 2.874c-.99 0-1.79.803-1.79 1.792v12.918c0 .989.8 1.79 1.79 1.79h25.834c.99 0 1.79-.801 1.791-1.79V12.916c0-.989-.802-1.791-1.79-1.792H18.082ZM25.833 16a2.084 2.084 0 1 1 0 4.17 2.084 2.084 0 0 1 0-4.17Zm10.334 0a2.084 2.084 0 1 1-.002 4.168A2.084 2.084 0 0 1 36.167 16Zm-3.73-7.75v1.585h-2.874V8.25h2.875ZM31 3.73c.794 0 1.438.644 1.438 1.438V7.25h-2.875V5.167c0-.794.643-1.438 1.437-1.438Z"
    />
  </Svg>
);
export default BotIcon60;
